<template>
  <transition name="card">
    <div class="business-card-container" v-show="cardShow">
      <div class="card-header">
        <div class="logo-container">
          <div class="logo">
            <img src="@/assets/image/card-logo.png" alt=""/>
          </div>
          <div class="close-btn" @click="close">
            <img src="@/assets/image/icon-card-close.png" alt=""/>
          </div>
        </div>
        <div class="company-msg">
          <span>杭州辰戈科技有限公司</span>
          <span>Hangzhou Chenge Technology Co., Ltd</span>
        </div>
      </div>
      <div class="card-body">
        <div class="msg-container">
          <div class="logo">
            <img src="@/assets/image/icon-phone.png" alt=""/>
          </div>
          <div class="msg">
            <span>联系电话</span>
            <span>+86 158-8887-9301</span>
          </div>
        </div>
        <div class="msg-container">
          <div class="logo">
            <img src="@/assets/image/icon-location.png" alt=""/>
          </div>
          <div class="msg">
            <span>公司地址</span>
            <span>+杭州市西湖区蓝海时代国际大厦1号楼A12A13</span>
          </div>
        </div>
        <div class="msg-container">
          <div class="logo">
            <img src="@/assets/image/icon-wx.png" alt=""/>
          </div>
          <div class="msg">
            <span>微信客服</span>
            <span>扫码获得业务帮助</span>
          </div>
        </div>
        <div class="qr-code-container"></div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    data() {
      return {
        cardShow: false,
      };
    },
    methods: {
      open() {
        this.cardShow = true;
      },
      close() {
        this.cardShow = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card-enter-active,
  .card-leave-active {
    transition: opacity .3s;
  }

  .card-enter,
  .card-leave-to {
    opacity: 0;
  }

  .business-card-container {
    width: 400px;
    height: 650px;
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.3);
    background: #ffffff;
    position: fixed;
    bottom: 25px;
    right: 25px;
    z-index: 10;

    .card-header {
      height: 140px;
      padding: 20px;
      background-image: linear-gradient(270deg, #0090ff 0%, #0057ff 100%);

      .logo-container {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo {
          img {
            height: 20px;
          }
        }

        .close-btn {
          cursor: pointer;
          user-select: none;

          img {
            height: 16px;
          }
        }
      }

      .company-msg {
        margin-top: 30px;

        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 22px;
          color: #ffffff;
        }

        span + span {
          opacity: 0.5;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }

    .card-body {
      padding: 30px;

      .msg-container {
        display: flex;
        margin-bottom: 30px;

        .logo {
          margin-right: 14px;

          img {
            width: 30px;
            height: 30px;
          }
        }

        .msg {
          span {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #000000;
          }

          span + span {
            margin-top: 6px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #5e5e5e;
          }
        }
      }

      .qr-code-container {
        margin: -10px 0 0 44px;
        width: 180px;
        height: 180px;
        background: url("../assets/image/icon-weChat.png") no-repeat;
        background-size: 180px 180px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/businessCard.vue